




































import Vue from "vue";
import Component from "vue-class-component";
import MapMenu from "../menus/MapMenu.vue";
import FeaturesMenu from "../menus/FeaturesMenu.vue";
import TargetsMenu from "../menus/TargetsMenu.vue"
import ToolsMenu from "../menus/ToolsMenu.vue";
import AdminMenu from "../menus/AdminMenu.vue";

import GrupoMenu from "../menus/GrupoMenu.vue";


import {user} from "@/store"

@Component({
  components: {
    MapMenu,
    FeaturesMenu,
    TargetsMenu,
    ToolsMenu,
    AdminMenu,
    GrupoMenu,
  }
})
export default class NavDrawer extends Vue{
  get isAdmin(){
    return user.getters.isAdmin
  }
}
